import { render, staticRenderFns } from "./EquipoActivoForm.vue?vue&type=template&id=51d49596&scoped=true&"
import script from "./EquipoActivoForm.vue?vue&type=script&lang=ts&"
export * from "./EquipoActivoForm.vue?vue&type=script&lang=ts&"
import style0 from "./EquipoActivoForm.vue?vue&type=style&index=0&id=51d49596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d49596",
  null
  
)

export default component.exports